import React from 'react';
import { Truck } from '../../../../../../../types/dbTypes';
import type { TimeRangePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useScreenView } from '../../../../../../../utils/ScreenViewContext';
import { Select } from 'antd';

const { RangePicker } = DatePicker;

const rangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Last Week', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Last 2 Weeks', value: [dayjs().add(-14, 'd'), dayjs()] },
  { label: 'Last Month', value: [dayjs().add(-30, 'd'), dayjs()] },
  { label: 'Last 3 Months', value: [dayjs().add(-90, 'd'), dayjs()] },
  { label: 'Last Year', value: [dayjs().add(-365, 'd'), dayjs()] },
  { label: 'Last 3 Years', value: [dayjs().add(-(365 * 3), 'd'), dayjs()] },
];

function ChartFiltersWidget({
  addClass,
  trucks,
  setSelectedTruck,
  selectedTruck,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  loadingTrucks,
  isPreActive,
}: {
  addClass?: string;
  trucks: Truck[];
  setSelectedTruck: (truck_id: string) => void;
  selectedTruck: string;
  loadingTrucks: boolean;
  startDate: Date | undefined;
  endDate: Date;
  setStartDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
  isPreActive: boolean;
}) {
  const { screenView } = useScreenView();

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <>
            <style>{`
              @media (max-width: 1024px) {
                .ant-picker-dropdown {
                  max-width: calc(100vw - 48px) !important;
                  overflow: hidden !important;
                }
                .ant-picker-dropdown .ant-picker-panel-container {
                  overflow-x: auto !important;
                  max-width: calc(100vw - 48px) !important;
                }
                .ant-picker-dropdown .ant-picker-panels {
                  display: flex !important;
                  flex-wrap: nowrap !important;
                  width: max-content !important;
                }
                .ant-picker-dropdown .ant-picker-panel {
                  min-width: 280px !important;
                }
              }
            `}</style>
            <div
              className={`flex w-full flex-col justify-between space-y-4 pt-4 align-middle md:flex-row md:space-y-0 lg:pt-0 ${addClass} h-full min-h-full lg:max-w-[1148px]`}
            >
              <Select
                value={selectedTruck}
                onChange={setSelectedTruck}
                placeholder="Select Category"
                className="w-[25%] disabled:cursor-not-allowed disabled:opacity-60"
                disabled={isPreActive}
              >
                <Select.Option value="all">All Trucks</Select.Option>
                {trucks.map((truck) => (
                  <Select.Option key={truck?.truck_id} value={truck?.truck_id}>
                    {truck?.truck_display_name + ' ' + truck?.vehicle_id_number}
                  </Select.Option>
                ))}
              </Select>
              <RangePicker
                popupStyle={{
                  borderColor: '#F7A826',
                  accentColor: '#F7A826',
                  borderBlockColor: '#F7A826',
                }}
                value={[dayjs(startDate), dayjs(endDate)]}
                presets={rangePresets}
                disabled={isPreActive}
                onChange={(dates) => {
                  if (dates) {
                    setStartDate(dates[0]?.toDate() ?? new Date());
                    setEndDate(dates[1]?.toDate() ?? new Date());
                  }
                }}
                className="custom-range-picker disabled:cursor-not-allowed disabled:opacity-60"
              />
            </div>
          </>
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default ChartFiltersWidget;
